import { useGlobal } from "../../../contexts/globalContext";
import { useJanusContext } from "../../../contexts/janus/JanusContext";
import Janus from "../../../utils/janus";
import { isChrome, isFirefox } from "../../../utils/userAgent";

import { SCREEN_SWITCH_STEP_COLLECTION } from "./constants";
import { useScreenSwitchUtils } from "./useScreenSwitchUtils";
import { useSwitchScreen } from "./useSwitchScreen";

export const useScreenSwitchSteps = () => {
  const { switchScreen } = useSwitchScreen();
  const {
    SCREEN_STATE,
    SET_SCREEN_STATE,
    MEDIA_TRACKS,
    MEDIA_TRACK_IDS,
    SET_SCREEN_SWITCH_STEP,
    SCREEN_SWITCH_DEBUG_MODE,
    MAIN_SCREEN_STREAM_LOADED,
    SET_MAIN_SCREEN_STREAM_LOADED,
    SET_SCREEN_IS_MAIN_FG,

    // STREAM CONTAINERS
    SCREEN_STREAM_TEMP_REF,
    SCREEN_STREAM_AUDIO_REF,

    // MIDIA ELEMENTS IN USE
    VIDEO_MAIN,
    VIDEO_MAIN_PARENT,
    VIDEO_MINI,
    VIDEO_TEMP_HIDDEN,
    VIDEO_TEMP,
    AUDIO_SCREEN_SOUND,
    AUDIO_SCREEN,
  } = useGlobal();
  const { showDebugMiniVideos, updateProgress, prepareMini, setMini } = useScreenSwitchUtils();
  const { oldScreensArray } = useJanusContext();

  const changeFocusTo = (el) => {
    if (!el) return;

    if (el.id === "video__screen-temp-2") {
      if (document.fullscreenElement) {
        const screen = oldScreensArray.find((oldScreen) => oldScreen.id === SCREEN_STATE.currentScreen.id);
        VIDEO_TEMP.current.style.transform = `scale(${screen.scale})`;
      }

      VIDEO_MAIN.current.style.zIndex = 0;
      VIDEO_MINI.current.style.opacity = 1;
      VIDEO_MAIN.current.style.opacity = 0;

      SET_SCREEN_IS_MAIN_FG(false);
    } else if (el.id === "video__screen-main-2") {
      if (document.fullscreenElement) {
        const screen = oldScreensArray.find((oldScreen) => oldScreen.id === SCREEN_STATE.currentScreen.id);
        VIDEO_MAIN.current.style.transform = `scale(${screen.scale})`;
      }

      VIDEO_MAIN.current.removeAttribute("style");
      VIDEO_MINI.current.removeAttribute("style");

      VIDEO_MAIN_PARENT.current.classList.remove("switching");

      SET_SCREEN_IS_MAIN_FG(true);
    }
  };

  const handleBeginPutTargetMiniIntoTemp = (baseScreen) => {
    setMini(SCREEN_STATE.currentScreen.id, prepareMini());
    SET_MAIN_SCREEN_STREAM_LOADED(false);
    console.log("SCREEN_SWITCH_STEP_ENUM.BEGIN_PUT_TARGET_MINI_INTO_TEMP");
    const targetScreenMiniTrackName = oldScreensArray.find((oldScreen) => oldScreen.id === SCREEN_STATE.currentScreen.id).mini_track_name;
    // Janus.attachMediaStream(VIDEO_MINI.current, SCREEN_STREAM_TEMP_REF.current);
    if (isFirefox) {
      SCREEN_STREAM_TEMP_REF.current = new MediaStream();
      SCREEN_STREAM_TEMP_REF.current.addTrack(MEDIA_TRACKS[targetScreenMiniTrackName]);
      Janus.attachMediaStream(VIDEO_TEMP_HIDDEN.current, SCREEN_STREAM_TEMP_REF.current);
      Janus.attachMediaStream(VIDEO_TEMP.current, SCREEN_STREAM_TEMP_REF.current);
    } else {
      MEDIA_TRACK_IDS
        // filter next track
        .filter((x) => x !== targetScreenMiniTrackName)
        // filter base track
        .filter((x) => x !== baseScreen.mini_track_name)
        // remove remaining tracks
        .forEach((x) => SCREEN_STREAM_TEMP_REF.current.removeTrack(MEDIA_TRACKS[x]));

      console.log(SCREEN_STREAM_TEMP_REF.current.getTracks());

      SET_SCREEN_SWITCH_STEP({
        step: SCREEN_SWITCH_DEBUG_MODE ? SCREEN_SWITCH_STEP_COLLECTION.XXX__DEBUG : SCREEN_SWITCH_STEP_COLLECTION.XXX,
      });
    }
    showDebugMiniVideos();
    updateProgress(SCREEN_SWITCH_STEP_COLLECTION.BEGIN_PUT_TARGET_MINI_INTO_TEMP);
  };

  const handleXxx = () => {
    console.log("SCREEN_SWITCH_STEP_ENUM.XXX");
    SCREEN_STREAM_TEMP_REF.current
      .getTracks()
      .filter((x) => {
        console.log("track: ", x, "track.label: ", x.label, x.label === "janusv105-mini");
        return x.label === "janusv105-mini";
      })
      .forEach((x) => {
        console.log("track: ", x);
        SCREEN_STREAM_TEMP_REF.current.removeTrack(x);
      });
    console.log(SCREEN_STREAM_TEMP_REF.current.getTracks());

    showDebugMiniVideos();
    updateProgress(SCREEN_SWITCH_STEP_COLLECTION.XXX);
  };

  const handleTempVideoResizeShowTempVideo = () => {
    console.log("SCREEN_SWITCH_STEP_ENUM.TEMP_VIDEO_RESIZE_SHOW_TEMP_VIDEO");
    changeFocusTo(VIDEO_TEMP.current);

    SET_SCREEN_SWITCH_STEP({
      step: SCREEN_SWITCH_DEBUG_MODE
        ? SCREEN_SWITCH_STEP_COLLECTION.SWITCH_TO_BASE_SCREEN_STREAM__DEBUG
        : SCREEN_SWITCH_STEP_COLLECTION.SWITCH_TO_BASE_SCREEN_STREAM,
    });

    if (isChrome) {
      const targetScreenMiniTrackName = oldScreensArray.find((oldScreen) => oldScreen.id === SCREEN_STATE.currentScreen.id).mini_track_name;

      console.log(targetScreenMiniTrackName);

      MEDIA_TRACK_IDS.filter((mid) => mid !== targetScreenMiniTrackName).forEach((mid) => SCREEN_STREAM_TEMP_REF.current.addTrack(MEDIA_TRACKS[mid]));
    }

    showDebugMiniVideos();
    updateProgress(SCREEN_SWITCH_STEP_COLLECTION.TEMP_VIDEO_RESIZE_SHOW_TEMP_VIDEO);
  };

  const handleSwitchToBaseScreenStream = (baseScreen) => {
    console.log("SCREEN_SWITCH_STEP_ENUM.SWITCH_TO_BASE_SCREEN_STREAM");
    switchScreen(baseScreen.stream_id);

    showDebugMiniVideos();
    updateProgress(SCREEN_SWITCH_STEP_COLLECTION.SWITCH_TO_BASE_SCREEN_STREAM);
  };

  const handleMainVideoResizeSwitchToTargetScreenStream = () => {
    console.log("SCREEN_SWITCH_STEP_ENUM.MAIN_VIDEO_RESIZE_SWITCH_TO_TARGET_SCREEN_STREAM");
    switchScreen(SCREEN_STATE.currentScreen.id, true);
    console.log(SCREEN_STATE.currentScreen.id);

    showDebugMiniVideos();
    updateProgress(SCREEN_SWITCH_STEP_COLLECTION.MAIN_VIDEO_RESIZE_SWITCH_TO_TARGET_SCREEN_STREAM);
  };

  const handleMainVideoResizeShowMainVideo = () => {
    console.log("SCREEN_SWITCH_STEP_ENUM.MAIN_VIDEO_RESIZE_SHOW_MAIN_VIDEO");
    VIDEO_MAIN.current.removeAttribute("width");
    SET_SCREEN_STATE((p) => ({
      ...p,
      currentScreen: {
        ...p.currentScreen,
        state: "playing",
      },
    }));

    SET_SCREEN_SWITCH_STEP({
      step: SCREEN_SWITCH_DEBUG_MODE
        ? SCREEN_SWITCH_STEP_COLLECTION.END_PUT_BASE_MINI_INTO_TEMP__DEBUG
        : SCREEN_SWITCH_STEP_COLLECTION.END_PUT_BASE_MINI_INTO_TEMP,
    });

    showDebugMiniVideos();
    updateProgress(SCREEN_SWITCH_STEP_COLLECTION.MAIN_VIDEO_RESIZE_SHOW_MAIN_VIDEO);
  };

  const handleEndPutBaseMiniIntoTemp = (baseScreen) => {
    console.log("SCREEN_SWITCH_STEP_ENUM.END_PUT_BASE_MINI_INTO_TEMP");
    // switch temp back to 105-mini in order to make everyting ready again, this is the final step
    SCREEN_STREAM_TEMP_REF.current = new MediaStream();
    SCREEN_STREAM_TEMP_REF.current.addTrack(MEDIA_TRACKS[baseScreen.mini_track_name]);
    Janus.attachMediaStream(VIDEO_TEMP_HIDDEN.current, SCREEN_STREAM_TEMP_REF.current);
    Janus.attachMediaStream(VIDEO_TEMP.current, SCREEN_STREAM_TEMP_REF.current);

    if (isChrome) MEDIA_TRACK_IDS.forEach((t) => SCREEN_STREAM_TEMP_REF.current.addTrack(MEDIA_TRACKS[t]));

    showDebugMiniVideos();
    if (MAIN_SCREEN_STREAM_LOADED) {
      console.log("!!!! SWITCH TO FINAL STEP SINCE SCREEN IS LOADED BEFORE 6th STEP PASSED");
      SET_SCREEN_SWITCH_STEP({
        step: SCREEN_SWITCH_DEBUG_MODE
          ? SCREEN_SWITCH_STEP_COLLECTION.FINISH_LOADING_MAIN_STREAM__DEBUG
          : SCREEN_SWITCH_STEP_COLLECTION.FINISH_LOADING_MAIN_STREAM,
      });
    }

    updateProgress(SCREEN_SWITCH_STEP_COLLECTION.END_PUT_BASE_MINI_INTO_TEMP);
  };

  const handleFinishLoadingMainStream = () => {
    console.log("CHANGING_FOCUS!");
    console.log("!!!! SWITCH TO INSERT_AN_AUDIO_TRACK");
    changeFocusTo(VIDEO_MAIN.current);
    SET_SCREEN_SWITCH_STEP({
      step: SCREEN_SWITCH_DEBUG_MODE
        ? SCREEN_SWITCH_STEP_COLLECTION.INSERT_AN_AUDIO_TRACK__DEBUG
        : SCREEN_SWITCH_STEP_COLLECTION.INSERT_AN_AUDIO_TRACK,
    });
    updateProgress(SCREEN_SWITCH_STEP_COLLECTION.FINISH_LOADING_MAIN_STREAM);
  };

  const handleInsertAnAudioTrack = () => {
    console.log("!!!! INSERTING AN AUDIO TRACK");
    Janus.attachMediaStream(AUDIO_SCREEN_SOUND.current, SCREEN_STREAM_AUDIO_REF.current);

    SET_SCREEN_SWITCH_STEP({
      step: SCREEN_SWITCH_DEBUG_MODE ? SCREEN_SWITCH_STEP_COLLECTION.PLAY_AN_AUDIO_TRACK__DEBUG : SCREEN_SWITCH_STEP_COLLECTION.PLAY_AN_AUDIO_TRACK,
    });
    updateProgress(SCREEN_SWITCH_STEP_COLLECTION.INSERT_AN_AUDIO_TRACK);
  };

  const handlePlayAnAudioTrack = () => {
    console.log("!!!! PLAY AN AUDIO TRACK");
    AUDIO_SCREEN.current.play();

    updateProgress(SCREEN_SWITCH_STEP_COLLECTION.PLAY_AN_AUDIO_TRACK);
    SET_SCREEN_SWITCH_STEP({
      step: "WAITING",
    });
  };

  return {
    handleBeginPutTargetMiniIntoTemp,
    handleXxx,
    handleTempVideoResizeShowTempVideo,
    handleSwitchToBaseScreenStream,
    handleMainVideoResizeSwitchToTargetScreenStream,
    handleMainVideoResizeShowMainVideo,
    handleEndPutBaseMiniIntoTemp,
    handleFinishLoadingMainStream,
    handleInsertAnAudioTrack,
    handlePlayAnAudioTrack,
  };
};
